import { Link } from "react-router-dom";
import Carousel from "./Carousel";
import about from "./img/abtn.png";
import profile from "./img/mobile.png";
import feature from "./img/feature.jpg";
import icon07 from "./img/icon/icon-07-primary.png";
import icon06 from "./img/icon/icon-06-primary.png";
import icon03 from "./img/icon/icon-03-primary.png";
import icon04 from "./img/icon/icon-04-primary.png";
import icon10light from "./img/icon/icon-10-light.png";
import icon01light from "./img/icon/icon-01-light.png";
import icon06light from "./img/icon/icon-06-light.png";
import icon05light from "./img/icon/icon-05-light.png";
import icon08light from "./img/icon/icon-08-light.png";
import icon07light from "./img/icon/icon-07-light.png";
import Teamwork from "./img/icon/Teamwork.png";
import Integrity from "./img/icon/Integrity.png";
import Innovation from "./img/icon/Innovation.png";
import CustomerFocus from "./img/icon/CustomerFocus.png";
import team1 from "./img/team-1.jpg";
import team2 from "./img/team-2.jpg";
import team3 from "./img/team-3.jpg";
import team4 from "./img/team-4.jpg";
import AdityaBirla from "./img/partners/AdityaBirla.jpg";
import Bajaj1 from "./img/partners/Bajaj-allianz-general-insurance.webp";
import Bajaj2 from "./img/partners/bajaj-allianz-life-insurance-online.jpeg";
import BandhanLife from "./img/partners/BandhanLife.jpg";
import Cholamandalam from "./img/partners/Cholamandalam.jpg";
import Carehealthinsurance from "./img/partners/Carehealthinsurance.png";
import FutureGenerali from "./img/partners/FutureGenerali.png";
import GoDigit from "./img/partners/Go-Digit.png";
import hdfclife from "./img/partners/hdfc-life.jpg";
import ICICI_Lombard from "./img/partners/ICICI_Lombard.jpg";
import ICICI_Prudential from "./img/partners/ICICI_Prudential.jpg";
import IffcoTokio from "./img/partners/IffcoTokio.png";
import KotakGeneral from "./img/partners/KotakGeneral.jpg";
import Libertygeneral from "./img/partners/Libertygeneral.jpg";
import LIC from "./img/partners/LIC.jpg";
import Magma from "./img/partners/Magma.png";
import Manipal from "./img/partners/Manipal.png";
import MAxLife from "./img/partners/MAxLife.jpg";
import NationalInsuarnce from "./img/partners/NationalInsuarnce.jpg";
import NivaBupa from "./img/partners/NivaBupa.jpg";
import Oriental from "./img/partners/Oriental.png";
import raheja from "./img/partners/raheja.png";
import Reliance from "./img/partners/Reliance.jpg";
import Royal from "./img/partners/Royal.jpg";
import SBIG from "./img/partners/SBIG.png";
import Shriram from "./img/partners/Shriram.png";
import Star from "./img/partners/Star.png";
import TATAAIA from "./img/partners/TATAAIA.jpg";
import TataAIG from "./img/partners/TataAIG.png";
import NewIndia from "./img/partners/NewIndia.jpg";
import UnitedIndia from "./img/partners/UnitedIndia.jpg";
import UniversalSompo from "./img/partners/UniversalSompo.png";
import Zuno from "./img/partners/Zuno.jpg";

const HOME_FACTS_VALUES = [
  { title: "Integrity", icon: Integrity, delay: "0.1s" },
  { title: "Customer Focus", icon: CustomerFocus, delay: "0.2s" },
  { title: "Innovation", icon: Innovation, delay: "0.3s" },
  { title: "Teamwork", icon: Teamwork, delay: "0.4s" },
];

const HOME_PARTNER_LOGOS = [
  { src: AdityaBirla, label: "Aditya Birla Capital" },
  { src: Bajaj1, label: "Bajaj Allianz General Insurance" },
  { src: Bajaj2, label: "Bajaj Allianz Life Insurance" },
  { src: BandhanLife, label: "Bandhan Life" },
  { src: Carehealthinsurance, label: "Care Health Insurance" },
  { src: Cholamandalam, label: "Cholamandalam MS General Insurance" },
  { src: FutureGenerali, label: "Future Generali" },
  { src: GoDigit, label: "Go Digit General Insurance" },
  { src: hdfclife, label: "HDFC Life" },
  { src: ICICI_Lombard, label: "ICICI Lombard" },
  { src: ICICI_Prudential, label: "ICICI Prudential Life" },
  { src: IffcoTokio, label: "IFFCO Tokio General Insurance" },
  { src: KotakGeneral, label: "Kotak General Insurance" },
  { src: Libertygeneral, label: "Liberty General Insurance" },
  { src: LIC, label: "LIC" },
  { src: Magma, label: "Magma HDI General Insurance" },
  { src: Manipal, label: "Manipal Cigna Health Insurance" },
  { src: NationalInsuarnce, label: "National Insurance" },
  { src: MAxLife, label: "Max Life Insurance" },
  { src: NivaBupa, label: "Niva Bupa Health Insurance" },
  { src: Oriental, label: "Oriental Insurance" },
  { src: raheja, label: "Raheja QBE General Insurance" },
  { src: Reliance, label: "Reliance General Insurance" },
  { src: Royal, label: "Royal Sundaram General Insurance" },
  { src: SBIG, label: "SBI General Insurance" },
  { src: Shriram, label: "Shriram General Insurance" },
  { src: Star, label: "Star Health Insurance" },
  { src: TataAIG, label: "Tata AIG General Insurance" },
  { src: NewIndia, label: "The New India Assurance" },
  { src: UnitedIndia, label: "United India Insurance" },
  { src: UniversalSompo, label: "Universal Sompo General Insurance" },
  { src: Zuno, label: "Zuno General Insurance" },
  { src: TATAAIA, label: "Tata AIA Life Insurance" },
];

const PARTNERS_PER_ROW = 11;
const HOME_PARTNER_ROWS = [0, 1, 2].map((i) =>
  HOME_PARTNER_LOGOS.slice(i * PARTNERS_PER_ROW, (i + 1) * PARTNERS_PER_ROW)
);

function Home() {
  window.scrollTo(0, 0);
  return (
    <main id="main-content" className="home-page">
      <Carousel />

      {/* <!-- About Start --> */}
      <section
        className="container-xxl py-4 py-lg-5"
        aria-labelledby="home-about-title"
      >
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative overflow-hidden rounded ps-3 pt-3 ps-md-5 pt-md-5 h-100 home-about-visual">
                <img
                  className="w-100 h-100"
                  src={about}
                  alt="About Ebix Insurance"
                  style={{ objectFit: "cover" }}
                  loading="lazy"
                />
                <div className="position-absolute top-0 start-0 bg-white rounded pe-2 pb-2 home-about-badge-wrap">
                  <div className="d-flex flex-column justify-content-center text-center bg-primary rounded h-100 p-2 p-md-3">
                    <h1 className="text-white mb-0 fs-1 fs-md-1">25</h1>
                    <h2 className="text-white fs-6 fs-md-5 mb-0">Years</h2>
                    <h5 className="text-white mb-0 small fs-6 fs-md-5">
                      Experience
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="h-100">
                <p className="home-eyebrow text-primary fw-semibold text-uppercase mb-2">
                  About us
                </p>
                <h2
                  id="home-about-title"
                  className="display-6 mb-3 mb-md-4 text-break"
                >
                  We're Here To Assist You With Exploring Protection
                </h2>
                <p className="fs-6 fs-md-5 text-primary mb-4">
                  Our commitment to expertise, comprehensive coverage, and
                  personalized service sets us apart as a trusted partner for
                  our clients
                </p>
                <div className="row g-4 mb-4">
                  <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                      <img className="flex-shrink-0 me-3" src={icon04} alt="Flexible Insurance icon" loading="lazy" />
                      <h5 className="mb-0">Flexible Insurance Plans</h5>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <img className="flex-shrink-0 me-3" src={icon03} alt="Money Back Guarantee icon" loading="lazy" />
                      <h5 className="mb-0">Money Back Guarantee</h5>
                    </div>
                  </div>
                </div>
                <p className="mb-4">
                  Our mission is to be the most trusted and respected insurance
                  broking company in the industry, known for our exceptional
                  service, expertise, and commitment to our clients.
                </p>
                <div className="border-top mt-4 pt-4">
                  <div className="d-flex flex-wrap align-items-center gap-2 gap-md-3">
                    <img
                      className="flex-shrink-0 rounded-circle me-md-1"
                      src={profile}
                      alt="Company profile"
                      loading="lazy"
                    />
                    <h5 className="mb-0 fs-6 fs-md-5 text-break">
                      Call Us: +91 8433720891
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- About End --> */}

      {/* <!-- Facts Start --> */}
      <section
        className="home-facts-section"
        aria-labelledby="home-facts-vision-title"
      >
        <div className="container-fluid overflow-hidden my-4 my-md-5 px-lg-0">
          <div className="container facts px-lg-0">
            <div className="row g-0 gx-0 gy-4 gy-lg-0 mx-lg-0 align-items-stretch">
              <div
                className="col-lg-6 facts-text wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="h-100 px-4 px-md-5 ps-lg-0 d-flex flex-column justify-content-center">
                  <p className="home-eyebrow text-white text-opacity-90 fw-semibold text-uppercase mb-2 mb-md-3">
                    Insure Karo, Secure Raho
                  </p>
                  <h2
                    id="home-facts-vision-title"
                    className="text-white mb-3 mb-md-4 fs-2 fs-md-3"
                  >
                    Our Vision
                  </h2>
                  <p className="text-light mb-4 mb-md-5 small fs-5 fs-md-5">
                    We make insurance easier to understand and access through
                    clear guidance and dependable service. As your broker, we
                    help you choose coverage that fits your needs—keeping the
                    process straightforward, transparent, and focused on
                    protecting what matters most.
                  </p>
                  <Link
                    to="/about"
                    className="btn btn-secondary py-3 px-4 px-md-5 w-md-auto align-self-md-center"
                  >
                    More Details
                  </Link>
                </div>
              </div>
              <div
                className="col-lg-6 facts-counter wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="h-100 px-4 px-md-5 ps-lg-0 d-flex flex-column justify-content-center">
                  <h2
                    id="home-facts-values-title"
                    className="text-dark mb-3 mb-md-4 fs-2 fs-md-3"
                  >
                    Our Values
                  </h2>
                  <div className="row g-3">
                    {HOME_FACTS_VALUES.map(({ title, icon, delay }) => (
                      <div
                        key={title}
                        className="col-sm-6 home-facts-value-tile wow fadeIn"
                        data-wow-delay={delay}
                      >
                        <div className="bg-light rounded-3 h-100 p-2 p-sm-3 shadow-sm">
                          <div className="bg-white border border-light rounded-3 d-flex flex-column justify-content-center align-items-center text-center h-100 py-4 px-3">
                            <img
                              className="mb-3 home-facts-value-icon"
                              src={icon}
                              alt={title}
                              loading="lazy"
                            />
                            <h3 className="mb-0 fs-6 fs-md-5 fw-semibold">
                              {title}
                            </h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Facts End --> */}

      {/* <!-- Features Start --> */}
      <section className="container-xxl py-4 py-lg-5 bg-light border-top border-bottom">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <p className="home-eyebrow text-primary fw-semibold text-uppercase mb-2">
                Why us
              </p>
              <h2 className="display-6 mb-3 mb-md-4 text-break">
                Few Reasons Why People Choosing Us!
              </h2>
              <p className="mb-4">
                Our experienced professionals provide personalized guidance and
                recommendations. We offer a comprehensive range of insurance
                products from leading insurers. We negotiate with insurers to
                secure the best rates for our clients. We prioritize our
                clients' needs, providing prompt and efficient support.
              </p>
              <div className="row g-3">
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                  <div className="bg-light rounded h-100 p-3">
                    <div className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3">
                      <img
                        className="align-self-center mb-3"
                        src={icon06}
                        alt="Expert Advice icon"
                        loading="lazy"
                      />
                      <h5 className="mb-0">Expert Advice</h5>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                  <div className="bg-light rounded h-100 p-3">
                    <div className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3">
                      <img
                        className="align-self-center mb-3"
                        src={icon03}
                        alt="Wide Range of Options icon"
                        loading="lazy"
                      />
                      <h5 className="mb-0">Wide Range of Options</h5>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div className="bg-light rounded h-100 p-3">
                    <div className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3">
                      <img
                        className="align-self-center mb-3"
                        src={icon04}
                        alt="Exceptional Service icon"
                        loading="lazy"
                      />
                      <h5 className="mb-0">Exceptional Service</h5>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                  <div className="bg-light rounded h-100 p-3">
                    <div className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3">
                      <img
                        className="align-self-center mb-3"
                        src={icon07}
                        alt="Competitive Pricing icon"
                        loading="lazy"
                      />
                      <h5 className="mb-0">Competitive Pricing</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="position-relative rounded overflow-hidden h-100 home-features-visual">
                <img
                  className="w-100 h-100"
                  src={feature}
                  alt="Feature illustration"
                  style={{ objectFit: "cover" }}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Features End --> */}

      {/* <!-- Service Start --> */}
      <section
        className="container-xxl py-4 py-lg-5"
        aria-labelledby="home-services-title"
      >
        <div className="container">
          <div className="text-center mx-auto home-section-heading mb-5">
            <p className="home-eyebrow text-primary fw-semibold text-uppercase mb-2">
              What we offer
            </p>
            <h2 id="home-services-title" className="display-6 mb-3">
              We provide professional Insurance Services
            </h2>
            <p className="text-muted mb-0">
              Comprehensive solutions from life and health to corporate risk—backed
              by leading insurers.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
                    <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-primary rounded-end me-4">
                    <img className="img-fluid" src={icon10light} alt="Life Insurance icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">Life Insurance</h4>
                </div>
                <p className="mb-4">
                  Our life insurance plans provide financial protection to our
                  clients' loved ones in the event of their passing.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-success rounded-end me-4">
                    <img className="img-fluid" src={icon01light} alt="Health Insurance icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">Health Insurance</h4>
                </div>
                <p className="mb-4">
                  We provide individual and family health insurance plans that
                  offer comprehensive coverage for medical expenses.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-info rounded-end me-4">
                    <img className="img-fluid" src={icon05light} alt="Home Insurance icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">Home Insurance</h4>
                </div>
                <p className="mb-4">
                  Ensure your home is safe from unforeseen risks with our simple
                  home insurance policy.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-warning rounded-end me-4">
                    <img className="img-fluid" src={icon08light} alt="General Insurance icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">General Insurance</h4>
                </div>
                <p className="mb-4">
                  We offer a range of general insurance products, including
                  motor insurance, home insurance, and travel insurance.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-danger rounded-end me-4">
                    <img className="img-fluid" src={icon07light} alt="Corporate Insurance icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">Corporate Insurance</h4>
                </div>
                <p className="mb-4">
                  Our corporate insurance plans provide comprehensive coverage
                  for businesses, including liability insurance, property
                  insurance, and employee benefits.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item rounded h-100 p-4 p-lg-5">
                <div className="d-flex align-items-center flex-wrap ms-0 ms-lg-n5 mb-4 gap-2">
                  <div className="service-icon flex-shrink-0 bg-primary rounded-end me-4">
                    <img className="img-fluid" src={icon06light} alt="Risk Management icon" loading="lazy" />
                  </div>
                  <h4 className="mb-0 fs-6 fs-md-5">Risk Management</h4>
                </div>
                <p className="mb-4">
                  We help our clients identify and mitigate risks, providing
                  tailored risk management solutions that meet their unique
                  needs.
                </p>
                {/* <a className="btn btn-light px-3" href="">Read More</a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Service End --> */}

      {/* <!-- POSP / Appointment Start --> */}
      <section
        className="appointment home-posp-section"
        aria-labelledby="home-posp-title"
      >
        <div
          className="container-fluid my-4 my-md-5 wow fadeIn"
          data-wow-delay="0.1s"
        >
          <div className="container py-4 py-lg-5">
            <header className="text-center mx-auto home-posp-header mb-4 mb-lg-5">
              <p className="home-eyebrow text-white text-opacity-90 fw-semibold text-uppercase mb-2 mb-md-3">
                Partner program
              </p>
              <h2
                id="home-posp-title"
                className="text-white mb-0 fs-3 fs-md-2 fw-bold text-break px-2"
              >
                POSP network & portal
              </h2>
            </header>
            <div className="row g-4 g-lg-5 align-items-start">
              <div
                className="col-lg-6 wow fadeIn"
                data-wow-delay="0.2s"
              >
                <div className="home-posp-card h-100 rounded-3 p-4 p-md-4">
                  <h3 className="text-white fs-5 fs-md-4 mb-3">
                    POSP network
                  </h3>
                  <p className="text-white text-opacity-90 mb-0 fs-6 fs-md-5 lh-lg">
                    Our nationwide network of trained, certified Point of Sales
                    Persons (POSPs) brings insurance guidance to clients across
                    India—so people get personalized support and expert advice
                    wherever they are.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-6 wow fadeIn home-posp-col-second"
                data-wow-delay="0.35s"
              >
                <div className="home-posp-card h-100 rounded-3 p-4 p-md-4">
                  <h3 className="text-white fs-5 fs-md-4 mb-3">
                    POSP portal
                  </h3>
                  <p className="text-white text-opacity-90 mb-0 fs-6 fs-md-5 lh-lg">
                    A dedicated digital workspace where POSPs can sell and
                    service policies securely—manage business operations in one
                    place and deliver a smooth experience for customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- POSP / Appointment End --> */}

      {/* <!-- Team Start --> */}
      {/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">Meet Our Professional Team Members</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team1} alt="Team member 1" loading="lazy" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team2} alt="Team member 2" loading="lazy" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team3} alt="Team member 3" loading="lazy" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team4} alt="Team member 4" loading="lazy" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
      {/* <!-- Team End --> */}
      <section
        className="home-partners-section py-4 py-lg-5 bg-light border-top"
        aria-labelledby="home-partners-title"
      >
        <div className="container">
          <div className="text-center mx-auto home-section-heading mb-4 mb-md-5 px-2">
            <p className="home-eyebrow text-primary fw-semibold text-uppercase mb-2">
              Insurers
            </p>
            <h2
              id="home-partners-title"
              className="fs-3 fs-md-2 mb-3 text-break"
            >
              Our partners
            </h2>
            <p className="text-muted mb-0 fs-6">
              Trusted relationships with leading insurers across India.
            </p>
          </div>
        </div>
        <div
          className="home-partners-marquees px-2 px-md-3"
          role="list"
          aria-label="Partner insurer logos"
        >
          {HOME_PARTNER_ROWS.map((row, rowIndex) => (
            <div
              key={`partner-row-${rowIndex}`}
              className="marquee-container home-partners-marquee-row overflow-hidden bg-white shadow-sm rounded-3 border border-light"
            >
              <div className="marquee-content home-partners-marquee-track d-flex align-items-center">
                {row.map(({ src, label }) => (
                  <div
                    key={label}
                    className="marquee-item mx-2 flex-shrink-0 d-flex align-items-center justify-content-center"
                    role="listitem"
                  >
                    <img
                      className="home-partners-logo img-fluid"
                      src={src}
                      alt={label}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
export default Home;
